export const BUTTON_DRAGGED_TO_DEEP_SUCCESS = "BUTTON_DRAGGED_TO_DEEP_SUCCESS";
export const BUTTON_DRAGGED_TO_SHALLOW_SUCCESS =
  "BUTTON_DRAGGED_TO_SHALLOW_SUCCESS";
